export default {
  container: {
    backgroundColor: "transparent"
  },
  item: {
    backgroundColor: "transparent"
  }
};
